import React, {
  memo,
  useMemo,
  useState,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import difference from 'lodash/difference';
import without from 'lodash/without';
import reject from 'lodash/reject';
import omit from 'lodash/omit';
import Dropdown from '@active/react-ui/Dropdown';
import MenuItemList from '@active/react-ui/MenuItemList';
import MenuItem from '@active/react-ui/MenuItem';
import { useLocale } from '@active/react-utils/i18n';
import { setPaymentsInfoUsedForPay, setUsedPaymentMethods } from '../paymentMethodsSlice';
import paymentMethodsMap from '../../../../../../shared/config/paymentMethodsMap';
import methodsMap from '../config/methodsMapConfig';

const paymentMethodsLabelMap = {
  ...paymentMethodsMap,
  PINPAD: 'checkout.lib.components.common.debitCard',
  ECHECK: 'checkout.lib.components.text.echeck',
};
const PaymentMethod = ({ errorCallback }) => {
  const [ currentPayment, setCurrentPayment ] = useState();
  const dispatch = useDispatch();
  const { i18n } = useLocale();

  const {
    entities: {
      paymentMethods: {
        availablePaymentMethodTypes,
      },
    },
    paymentsInfoUsedForPay,
    usedPaymentMethods,
  } = useSelector(state => state.paymentMethods);

  const paymentMethodChanged = useCallback((val) => {
    setCurrentPayment(val);
    const newPaymentsInfoUsedForPay = reject(paymentsInfoUsedForPay, { paymentMethodType: currentPayment });
    dispatch(setPaymentsInfoUsedForPay(newPaymentsInfoUsedForPay));
    dispatch(setUsedPaymentMethods(without(usedPaymentMethods, currentPayment).concat(val)));
  }, [ currentPayment, paymentsInfoUsedForPay, dispatch, usedPaymentMethods ]);

  const CurrentPaymentField = useMemo(() => methodsMap[currentPayment], [ currentPayment ]);

  const paymentMethodList = useMemo(() => {
    return difference(availablePaymentMethodTypes, omit(usedPaymentMethods, currentPayment));
  }, [ availablePaymentMethodTypes, usedPaymentMethods, currentPayment ]);

  const menuList = useMemo(() => {
    return paymentMethodList.map(type => ({
      value: type,
      text: i18n(paymentMethodsLabelMap[type]),
    }));
  }, [ i18n, paymentMethodList ]);

  return (
    <div className="multi-payment-method">
      <div className='methods-select'>
        <Dropdown placeholder={i18n('checkout.lib.components.text.chooseRefundMethod')} value={currentPayment} onChange={paymentMethodChanged}>
          <MenuItemList>
            {
              menuList.map(({ value, text }) => <MenuItem key={value} value={value}>
                {text}
              </MenuItem>)
            }
          </MenuItemList>
        </Dropdown>
      </div>
      {
        currentPayment && <div className='selected-content'>
          {CurrentPaymentField && <CurrentPaymentField
            paymentMethodType={currentPayment}
            errorCallback={errorCallback}/>}
        </div>
      }
    </div>
  );
};

export default memo(PaymentMethod);
